import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from 'helpers/axios';
import { errorMessage } from 'helpers/common';
import * as Sentry from "@sentry/react";

const fetchRoles = createAsyncThunk('fetchRoles', async (withUser = false, {getState, rejectWithValue }) => {
  const url = withUser ? '/settings/roles?include=users' : '/settings/roles';

  try {
    const { data, status } = await api.get(url);
    if (status === 200) return data;
  } catch (err) {
    Sentry.captureException(err);
    return rejectWithValue(errorMessage(err, 'fetch roles'));
  }
});

export const rolesSlice = createSlice({
  name: 'roles',
  initialState: {
    data: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.data = action.payload.data;
      });
  }
});

export const getRoles = (state) => state.roles.data

export { fetchRoles };

export default rolesSlice.reducer;
